module.exports = __webpack_public_path__ + "assets/images/project/stylised-images/party-ind.jpg?v=c05211e4";